// extracted by mini-css-extract-plugin
export var wrapper = "Card-module--wrapper--K1mu4";
export var card = "Card-module--card--B-MLk";
export var hide = "Card-module--hide--q7e9Y";
export var disabled = "Card-module--disabled--3LTzx";
export var front = "Card-module--front--3N55f";
export var back = "Card-module--back--2XXR1";
export var img = "Card-module--img--qFqAU";
export var active = "Card-module--active--hJnUJ";